import { css } from "@emotion/react";
import { Button, Theme, useTheme } from "@mui/material";
import { useCallback, useState } from "react";

import CreateAccountLead from "~/components/common/CreateAccountLead";
import { responseModalContentRootDesignStyle } from "~/components/database/detail/response-modal-content/design";
import AnswerForm from "~/components/database/detail/response-modal-content/response-form/AnswerForm";
import {
  Props,
  updateResponseAnswer,
} from "~/components/database/detail/response-modal-content/response-form/lib";
import { flexRow } from "~/lib/client/design";
import { useAppContext } from "~/pages/_app";

const SpResponseForm = ({
  stepToConfirm,
  setResponseAnswers,
  responseAnswers,
  form,
}: Props) => {
  const { currentUser } = useAppContext();
  const theme = useTheme();

  // 各投稿への入力の結果
  const [validationResults, setValidationResults] = useState<boolean[]>(
    form.questions.map(() => false)
  );

  // 与えられた position ごとに validation の結果を更新できるようにする
  // FIXME: `updateResponseAnswer` と position なのか quest id なのかで一貫性が保てておらず、ややわかりづらいから治したい author: @funwarioisii
  const updateValidationResult = useCallback(
    (position: number) => (isValid: boolean) =>
      setValidationResults((prev) =>
        prev.map((validationResult, index) =>
          index === position ? isValid : validationResult
        )
      ),
    [setValidationResults]
  );

  if (!currentUser) {
    return (
      <div css={rootStyle(theme)}>
        <CreateAccountLead
          label={"データベースに書き込むにはログインが必要です。"}
        />
      </div>
    );
  }

  return (
    <div css={rootStyle(theme)}>
      <p css={titleStyle}>{form.title}</p>
      <hr color={theme.palette.divider} />
      <p css={descriptionStyle}>{form.description}</p>
      <hr color={theme.palette.divider} />
      <div css={answerFormsContainerStyle}>
        {form.questions.map((question) => {
          const responseAnswerInput = responseAnswers.find(
            (responseAnswer) => responseAnswer.questionId === question.id
          );
          if (!responseAnswerInput) {
            return null;
          }

          return (
            <AnswerForm
              key={question.id}
              question={question}
              updateResponseAnswer={updateResponseAnswer(
                question.id,
                setResponseAnswers
              )}
              setIsValid={updateValidationResult(question.position)}
              responseAnswerInput={responseAnswerInput}
            />
          );
        })}
      </div>
      <div css={buttonContainerStyle}>
        <Button
          onClick={stepToConfirm}
          disabled={
            !validationResults.every((validationResult) => validationResult)
          }
          variant="contained"
          style={{
            margin: "0.5rem",
          }}
          color={"primary"}
        >
          確認する
        </Button>
      </div>
    </div>
  );
};

const rootStyle = (theme: Theme) => [
  responseModalContentRootDesignStyle,
  css`
    background-color: ${theme.palette.background.paper};
    padding-bottom: 2rem;

    p {
      margin: 0;
    }

    hr {
      margin: 0;
    }
  `,
];

const titleStyle = css`
  font-size: 24px;
  font-weight: 600;
  padding: 1rem;
`;

const descriptionStyle = css`
  padding: 1rem;
  white-space: pre-wrap;
  word-break: break-all;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
  line-height: 1.5;
`;

const answerFormsContainerStyle = css``;

const buttonContainerStyle = css`
  ${flexRow};
  justify-content: flex-end;
`;

/**
 * @package
 */
export default SpResponseForm;
